<template>
  <div>
    <md-app>
      <md-app-content class="c-content">
        <Handbook @signed="showSignedDialog" />
      </md-app-content>
    </md-app>
    <md-dialog :md-active.sync="signatureDialogVisible">
      <md-dialog-title>Sign Handbook</md-dialog-title>
      <div class="signed-modal-content">
      <div class="md-layout md-gutter">
        <div class="md-layout-item" v-if="isSigned()">
          <p>Thank you for signing the handbook.</p>
        </div>
        <div class="md-layout-item" v-if="!isSigned()">
          <p>
            I understand that this handbook describes important information about Company Name. Company Name has the sole discretion to alter these policies from time to time. I also understand that the revisions to these policies may supersede or eliminate one or more existing policies and that all such changes will be communicated through official notice channels.
          </p>
          <p>
            I understand that this handbook is neither a contract for employment, express or implied. I have read and will comply with both the policies contained here and any revisions made to it.
          </p>
          <md-field>
            <label>Name</label>
            <md-input v-model="signature.name"></md-input>
          </md-field>
        </div>
      </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="signatureDialogVisible = false">Close</md-button>
        <md-button class="md-primary" @click="signEvent" v-if="!isSigned()">Sign</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import Handbook from '@/components/Handbook.vue'
import HandbookSectionList from '@/components/admin/HandbookSectionList.vue'
import { mapState, mapActions } from 'vuex'
export default {
  name: "Member",
  components:{
    Handbook,
    HandbookSectionList
  },
  data() {
    return {
      signatureDialogVisible: false,
      signature: { name: '' }
    }
  },
  computed: {
    ...mapState({
      user: s => s.auth.user,
      handbook: s => s.handbook.handbook
    })
  },
  methods: {
    ...mapActions([
      'getHandbook',
      'getSections',
      'sign',
      'visit'
    ]),
    visited(){
      console.log("visited()")
      this.visit()
    },
    showSignedDialog(){
      this.signatureDialogVisible = true
    },
    signEvent() {
      this.sign(this.signature.name)
      this.signatureDialogVisible = false
    },
    isSigned(){
      return this.handbook && this.handbook.signed
    },
    isVisited(){
      return this.handbook && this.handbook.visited
    }

  },
  beforeMount() {
    this.getHandbook()
  },
  mounted() {
    this.$store.watch(
      (state) => state.handbook.handbook,
      () => {
        if(!this.isVisited()){
          this.visited()
        }
      }
    )
  }
}
</script>
<style>
.md-app {
  min-height: 100%;
}
.c-content {
  border: none !important;
  padding: 0px !important;
}
.signed-modal-content {
  padding: 0px 15px;
}
</style>
